// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { createPopper } from '@popperjs/core'
import * as bootstrap from "bootstrap"
import jquery from 'jquery'
import "trix"
import "@rails/actiontext"
import * as ActiveStorage from "@rails/activestorage"
import "./upload_progress"

window.jQuery = jquery
window.$ = jquery
window.createPopper = createPopper
window.bootstrap = bootstrap

// Start Active Storage for direct uploads
ActiveStorage.start()


// // Example starter JavaScript for disabling form submissions if there are invalid fields
// (() => {
//     'use strict'

//     // Fetch all the forms we want to apply custom Bootstrap validation styles to
//     const forms = document.querySelectorAll('.needs-validation')

//     // Loop over them and prevent submission
//     Array.from(forms).forEach(form => {
//         form.addEventListener('submit', event => {
//             if (!form.checkValidity()) {
//                 event.preventDefault()
//                 event.stopPropagation()
//             }

//             form.classList.add('was-validated')
//         }, false)
//     })
// })()

function showPopper(popper) {
    const menu = popper.state.elements.popper
    console.log(menu)

    if (menu.getAttribute('data-show') == 'true') {
        menu.removeAttribute('data-show');
    } else {
        menu.setAttribute('data-show', 'true');
    }

    // We need to tell Popper to update the tooltip position
    // after we show the tooltip, otherwise it will be incorrect
    popper.update();
}
window.showPopper = showPopper

console.log("before ready")
$(function () {
    console.log("ready")
    $(".dropdown-search").on("keyup", function () {
        var value = $(this).val().toLowerCase();

        $("#" + $(this).attr("data-list")).find(".dropdown-item").filter(function () {
            console.log($(this).text().toLowerCase().indexOf(value))
            $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
        });
    });

    $(window).on('hashchange', function (e) {
        console.log("hashchange")
    });
});

// Toggle .has-content on Trix editors so CSS can style filled vs empty
document.addEventListener("trix-change", function (event) {
    const editor = event.target
    if (editor.editor.getDocument().toString().trim().length > 1) {
        editor.classList.add("has-content")
    } else {
        editor.classList.remove("has-content")
    }
})

// Mark Trix editors that already have content on page load
document.addEventListener("turbo:load", function () {
    document.querySelectorAll("trix-editor").forEach(function (editor) {
        if (editor.editor && editor.editor.getDocument().toString().trim().length > 1) {
            editor.classList.add("has-content")
        }
    })
})

